import type { VoiceStatus } from "@/lib/voice/conversation";

export function isLiveSessionActive(status: VoiceStatus): boolean {
  return status === "connecting" || status === "listening" || status === "speaking";
}
